/**
 * @module
 * The DUI theme, as the web app sets it: DUI's colors and radius, Inter for
 * the sans font. A copy, not an import, since a client imports no other
 * client's code. The color scheme follows the system's.
 */

import { applyTheme } from "@dui/components/theme";

export const bootstrap = (): void => {
  applyTheme({ fonts: { sans: "Inter" } });
  const dark = globalThis.matchMedia("(prefers-color-scheme: dark)");
  const follow = (): void =>
    document.documentElement.setAttribute(
      "data-theme",
      dark.matches ? "dark" : "light",
    );
  follow();
  dark.addEventListener("change", follow);
};
